import {
  SHOW_KEYWORDS_SETUP_ALERT,
  HIDE_KEYWORDS_SETUP_ALERT,
  SHOW_COMPETITORS_SETUP_ALERT,
  HIDE_COMPETITORS_SETUP_ALERT,
} from '../types/alerts'

import { createActionTypes } from '.'

export const FETCH_ALERTS = createActionTypes('FETCH_ALERTS')
export const MARK_ALERTS_AS = createActionTypes('MARK_ALERTS_AS')
export const DELETE_ALERT = createActionTypes('DELETE_ALERT')
export const CLOSE_SITE_AUDIT_REPORT_ALERT = createActionTypes(
  'CLOSE_SITE_AUDIT_REPORT_ALERT',
)

export const fetchAlerts = (payload) => ({
  type: FETCH_ALERTS.action,
  payload,
})

export const fetchAlertsSuccess = (payload) => ({
  type: FETCH_ALERTS.success,
  payload,
})

export const markAlertsAs = (payload) => ({
  type: MARK_ALERTS_AS.action,
  payload,
})

export const deleteAlert = (payload) => ({
  type: DELETE_ALERT.action,
  payload,
})

export const closeSiteAuditReportAlert = () => ({
  type: CLOSE_SITE_AUDIT_REPORT_ALERT.action,
})

export const showKeywordsSetupAlert = (projectId, projectName) => ({
  type: SHOW_KEYWORDS_SETUP_ALERT,
  payload: {
    userId: null,
    alertId: `keywords_setup_${projectId}`,
    alertType: 'keywords_setup_alert',
    projectId,
    projectName: projectName || '',
    content: {
      message: 'complete_setup_alert_keywords',
    },
    date: new Date().toISOString(),
    seen: false,
  },
})

export const hideKeywordsSetupAlert = (projectId) => ({
  type: HIDE_KEYWORDS_SETUP_ALERT,
  payload: {
    projectId,
  },
})

export const showCompetitorsSetupAlert = (projectId, projectName) => ({
  type: SHOW_COMPETITORS_SETUP_ALERT,
  payload: {
    userId: null,
    alertId: `competitors_setup_${projectId}`,
    alertType: 'competitors_setup_alert',
    projectId,
    projectName: projectName || '',
    content: {
      message: 'complete_setup_alert_competitors',
    },
    date: new Date().toISOString(),
    seen: false,
  },
})

export const hideCompetitorsSetupAlert = (projectId) => ({
  type: HIDE_COMPETITORS_SETUP_ALERT,
  payload: {
    projectId,
  },
})
